import {
    ConversationSpec
} from '../entities/conversation'

interface CalendlyConfigs {
    url: string,
    parentElement: HTMLElement,
    prefill: object,
    utm: object
}

export interface CalendlyType {
    initInlineWidget(configs: CalendlyConfigs): void
}

declare let Calendly: CalendlyType | undefined

export function initInlineWidget(link: string, elementId: string) {
    const element = document.getElementById(elementId)
    if (!Calendly || !element) { return }

    Calendly.initInlineWidget({
        url: link + '?hide_event_type_details=1',
        parentElement: element,
        prefill: {},
        utm: {}
    })
}

export function isCalendlyEvent(event: MessageEvent) {
    return event.data.event && event.data.event.indexOf('calendly') === 0
}

export function hasCalendly(spec: ConversationSpec) {
    return spec.some(block => {
        return block.items.some(
            item =>
                item.type === 'ReceiveOption' &&
                item.link &&
                item.link.includes('calendly.com')
        )
    })
}
